import "./common-namespaces-client-CHyZgmlk.mjs";
const asExport = /*                      */ (namespace, fieldKey, defaultValue) => namespace[fieldKey] ?? defaultValue;
export {
  asExport
};
/*                                                    */
